import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'
import { PartnerProviderViewPage } from '@/features/partner/provider-view-page'

export const Route = createFileRoute(
  '/_authenticated/_organization/partner/providers/$providerOrgId'
)({
  beforeLoad: async () => {
    await requireRoles(['owner', 'admin', 'team_leader', 'finance'])
    await requireActiveSubscription()
  },
  component: PartnerProviderViewPage,
})
